import { readonly, ref } from 'vue'

import type { SnackbarState } from '@/types/interfaces/ui'

const state = ref<SnackbarState>({ isOpen: false, text: '', tone: 'default' })
let timer: ReturnType<typeof setTimeout> | undefined

function show(text: string, tone: SnackbarState['tone'] = 'default', duration = 3000) {
  if (timer) clearTimeout(timer)
  state.value = { isOpen: true, text, tone }
  timer = setTimeout(close, duration)
}

function close() {
  if (timer) clearTimeout(timer)
  timer = undefined
  state.value = { ...state.value, isOpen: false }
}

export function useSnackbar() {
  return {
    snackbar: readonly(state),
    show,
    showError: (text: string) => show(text, 'error'),
    showSuccess: (text: string) => show(text, 'success'),
    close,
  }
}
